import styled from 'styled-components';
import { rem, ellipsis } from 'polished';
import Icon from '../Icon';
import AvatarPerson from '../AvatarPerson';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

export const StyledBoxAvatar = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  line-height: ${rem('16px')};
  width: 100%;
`;

export const WrapperAvatarPerson = styled.span`
  border: ${rem('2px')} solid ${props => props.theme.colors.dark};
  border-radius: 50%;
  height: ${rem('65px')};
  margin-bottom: ${rem('8px')};
  width: ${rem('65px')};
`;

export const StyledAvatar = styled(AvatarPerson)`
  font-size: 200%;
  width: 100%;
  height: 100%;
  border: ${rem('2px')} solid ${props => props.theme.colors.light};
`;

export const StyledName = styled.h4`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  margin-bottom: 0;
  ${mediaqueries.greaterThan('mobile')`
      ${ellipsis('275px')};
  `};
`;

export const StyledJob = styled.p`
  ${ellipsis('98%')};
  font-size: ${props => props.theme.fontSize.xsmall};
  margin-bottom: ${rem('11px')};
  min-height: ${rem('15px')};
`;

export const StyledIcon = styled(Icon)`
  height: ${rem('22px')};
  width: ${rem('22px')};
`;

export const StyledGroupIcon = styled.ul`
  display: flex;
  padding: 0 0 ${rem('15px')} 0;
  position: relative;
  :after {
    background-color: ${props => props.theme.colors.dark};
    bottom: 0;
    content: '';
    height: ${rem('2px')};
    left: 50%;
    position: absolute;
    transform: translate(-50%, 0);
    width: ${rem('51px')};
  }
`;

export const StyledElements = styled.li`
  margin-left: ${rem('11px')};
  padding-left: 0;
  :first-child {
    margin-left: 0;
  }
  :before {
    content: none;
  }
`;
